export const iconSm = {
  width: "iconSizeSm",
};

export const iconBase = {
  width: "iconSizeBase",
};

export const iconMd = {
  width: "iconSizeMd",
};

export const iconLg = {
  width: "iconSizeLg",
};

export const iconXl = {
  width: "iconSizeXl",
};

export const icon2xl = {
  width: "iconSize2xl",
};

export const icon3xl = {
  width: "iconSize3xl",
};
